/* eslint-disable semi */
// const debug = process.env.NODE_ENV === 'development';

const TYPE_STR = 'string';
const TYPE_NUM = 'number';
const TYPE_BOOL = 'boolean';
const TYPE_DATE = 'date';
const TYPE_OBJECT = 'object';
const TYPE_ARRAY = 'array';
const TYPE_UNKNOWN = 'unknown';

class SasType {
  // 定数定義
  get STR () { return TYPE_STR };
  get NUM () { return TYPE_NUM };
  get BOOL () { return TYPE_BOOL };
  get DATE () { return TYPE_DATE };
  get OBJECT () { return TYPE_OBJECT };
  get UNKNOWN () { return TYPE_UNKNOWN };
  get ARRAY () { return TYPE_ARRAY };

  /**
   * 型が配列型か判定する
   * @param {*} type
   */
  isArray (type) {
    return this.getArrayLevel(type) > 0;
  }

  /**
   * 配列の階層数を取得する
   * @param {*} type
   */
  getArrayLevel (type) {
    return (type.match(/:/g) || []).length;
  }

  /**
   * 配列の要素の型を更新します
   * @param {*} type
   * @param {*} to
   */
  replaceItemType (type, to) {
    if (this.isArray(type)) {
      return type.replace(/:.[^:]+$/, ':' + to);
    } else {
      return to;
    }
  }

  getItemType (type) {
    return type.replace(/^array:/, '');
  }

  /**
   * 型を判定する
   *
   * 配列の場合のみ階層構造になる
   * 例) array:array:string
   *
   * @param {*} value
   */
  decide (value) {
    const type = this.decideType(value);
    if (type === TYPE_ARRAY) {
      const itemType = (value.length > 0) ? this.decide(value[0]) : TYPE_UNKNOWN;
      return `${type}:${itemType}`;
    } else {
      return type;
    }
  }

  decideType (value) {
    const objectType = Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
    switch (objectType) {
      case TYPE_STR:
      case TYPE_NUM:
      case TYPE_BOOL:
      case TYPE_DATE:
      case TYPE_OBJECT:
      case TYPE_ARRAY:
        return objectType;
      default:
        return TYPE_UNKNOWN;
    }
  }

  /**
   *
   * @param {*} type
   */
  trimTypeClass (type) {
    return type.replace(/\.[^:]+/g, '');
  }
}
export default new SasType();



// WEBPACK FOOTER //
// ./src/core/libs/SasType.js